import instance from "@/services/apiService";
import apiUrls from "@/services/apiUrls";
import store from "@/store";

const state = {
  eStorePaymentMethods: [],
  eStorePaymentMethod: null,
};

const getters = {
  eStorePaymentMethods: (state) => state.eStorePaymentMethods,
  eStorePaymentMethod: (state) => state.eStorePaymentMethod,
};

const actions = {
  async getEStorePaymentMethods({ commit }) {
    try {
      const response = await instance.get(
        `${apiUrls.ESTORE_PAYMENT_METHOD}?branch=${store.getters.selectedBranch.id}&published=1`
      );

      commit("getEStorePaymentMethods", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async resetEStorePaymentMethods({ commit }) {
    commit("getEStorePaymentMethods", []);
  }
};

const mutations = {
  getEStorePaymentMethods: (state, payload) => {
      state.eStorePaymentMethods = payload;

    // Set default selected payment method
    if (state.eStorePaymentMethods.length > 0) {
      state.eStorePaymentMethod = state.eStorePaymentMethods[0];
    }
  },

  setEStorePaymentMethod: (state, payload) => (state.eStorePaymentMethod = payload),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
